import { css } from '@/styled-system/css';

export const cardContainer = css({
  width: '100%',
  position: 'relative',
});

export const cardContent = css({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '12px',
  bg: 'hpxWhite',
  borderRadius: '12px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  color: 'hpxBlue600',
  textDecoration: 'none',
  boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  transitionProperty: 'all',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',

  _hover: {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const cardImage = css({
  width: '80px',
  height: '80px',
  borderRadius: '8px',
  objectFit: 'cover',
  flexShrink: 0,
});

export const cardInfo = css({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '1x',
});

export const cardTitlePriceContainer = css({
  flex: 1,
  minWidth: 0,
  paddingRight: '12x',
});

export const cardTitle = css({
  fontSize: 'sm',
  fontWeight: '600',
  color: 'hpxBlue600',
  margin: '0',
  lineHeight: '1.2',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const removeButton = css({
  position: 'absolute',
  top: '2x',
  right: '2x',
  bg: 'transparent',
  border: 'none',
  color: 'hpxGrey500',
  fontSize: 'tiny',
  cursor: 'pointer',
  padding: 0,
  transitionProperty: 'color',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',

  _hover: {
    color: 'hpxBlue600',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '4px',
  },
});

export const cardPrice = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxTeal500',
  marginTop: '2px',
});

export const cardDetails = css({
  fontSize: 'tiny',
  color: 'hpxGrey600',
  lineHeight: '1.3',
});

export const amenitiesContainer = css({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '6px',
  overflow: 'hidden',
});

export const amenityPill = css({
  whiteSpace: 'nowrap',
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '6px',
  fontWeight: '600',
  bg: 'hpxGrey100',
  color: 'hpxBlue600',
  fontSize: '10px',
  paddingX: '1x',
  paddingY: '2px',
});
